import styles from '../styles/dockedfloatingbutton.module.css';

const DockedFloatingActionButton = ({className = '',children,...props}) => {
    return(
        <button {...props} className={`${styles.dockedFloatingButton} ${className ? className : ''}`}>
            {children}
        </button>
    )
}

export default DockedFloatingActionButton;